<script setup lang="ts">
const props = defineProps<{
    title: string;
    subTitle: string;
    description: string;
    img: string;
}>();
const modalsStore = useModalsStore();

function handleOpenModal() {
    modalsStore.openModal('CTA');
};
function handleOnCall() {
    window.location.href = 'tel:02182800000';
};
</script>

<template>
  <div class="w-full bg-primary-800 pt-5 lg:pt-0 relative overflow-hidden">
    <div class="gridClass flex flex-col lg:flex-row py-20 gap-10 lg:gap-0">
        <div class="w-full lg:w-1/2 flex flex-col justify-center text-white">
            <div class="flex flex-col gap-5">
                <h1 class="text-secondary-600 text-center lg:text-start">{{ props?.title }}</h1>
                <p class="font-semibold text-[1.5rem] text-center lg:text-start">{{ props?.subTitle }}</p>
                <p class="text-body1-semibold text-center lg:text-start">{{ props?.description }}</p>
                <div class="flex flex-col lg:flex-row items-center gap-4">
                    <Button
                        variant="white"
                        :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                        size="Large"
                        pill
                        @click="handleOpenModal"
                    >
                        دمو و مشاوره رایگان
                    </Button>
                    <Button
                        type="Outline"
                        variant="white"
                        size="Large"
                        :append-icon="{ name: 'solar:phone-calling-bold' }"
                        pill
                        @click="handleOnCall"
                    >
                        استعلام شماره‌های موجود
                    </Button>
                </div>
            </div>
        </div>
        <div class="w-full lg:w-1/2 flex-center">
            <NuxtImg
                :src="props?.img"
                alt="خط تلفن رند ابری پیش‌شماره ۸ تهران"
                width="600" 
                height="412"
                sizes="250px md:600px"
                :preload="{ fetchPriority: 'high' }"
                loading="eager"
            />
        </div>
    </div>
  </div>
</template>